import { render } from "./ks-welcome-text-item.vue?vue&type=template&id=59a20650"
import script from "./ks-welcome-text-item.vue?vue&type=script&lang=js"
export * from "./ks-welcome-text-item.vue?vue&type=script&lang=js"

import "./ks-welcome-text-item.vue?vue&type=style&index=0&id=59a20650&lang=css"
script.render = render

export default script